import React, {FC, useEffect} from "react";
import style from "@src/pages/History/HistoryDetails/HistoryDetails.module.scss"
import {useSelector} from "react-redux";
import {selectUserInfo} from "@src/store/ducks/user/selectors";
import {FieldFormik} from "@src/components/common/FieldFormik/FieldFormik";
import {SelectCustom} from "@src/components/common/Select/SelectCustom";
import {TextAreaFormik} from "@src/components/common/TextAreaFormik/TextAreaFormik";
import {useFormikContext} from "formik";
import {selectSourceRegirstration} from "@src/store/ducks/orders/selectors";
import {FieldHistory} from "@src/pages/History/HistoryDetails/FieldHistory";
import {useCostCalculation} from "@src/customFunctions/СostСalculation";
import {useCostCalculationPreOrder} from "@src/customFunctions/СostСalculationPreOrder";

// TRAIN FLOW: add vehicleType
type Step4Props = {
    vehicleType: string,
    data: any
}

export const HistoryPreOrderStep4: FC<Step4Props> = ({data, vehicleType}) => {
    const {values}: any = useFormikContext();
    const user = useSelector(selectUserInfo)
    const dataSourceRegistrationFromApi = useSelector(selectSourceRegirstration)
    let dataSourceRegistration: any = []

    function dataPreparation() {
        dataSourceRegistration = Object.keys(dataSourceRegistrationFromApi).map(key => {
            return {
                value: key,
                label: dataSourceRegistrationFromApi[key]
            };
        });
    }

    dataPreparation()
    useCostCalculationPreOrder(vehicleType, data)
    return (
        <div className={style.additional}>
            <div className={style.title}>
                Дополнительные сведения
            </div>
            <div className={style['additional-wrap']}>
                <FieldFormik name='data.applicationDate' text={data.applicationDate} typeInput='input-date'
                             label='Дата заявки' svg={true}/>
                {user.roleId !== 2 ?
                    <SelectCustom className={'select-full'} data={dataSourceRegistration} name='sourceRegistration'
                                  heading='Выберите из списка'
                                  placeholder="Выберите из списка" labelTitle='Путь оформления'></SelectCustom>
                    :
                    <FieldFormik name='data.sourceRegistration' text={'Агент'} typeInput='input-date'
                                 label='Путь оформления' className={style['input-payment']}/>
                }
            </div>
            <TextAreaFormik name={'data.additionalExcursions'} label={'Особые отметки / Дополнительные экскурсии'}
                            placeholder={'Пример: Название экскурсии'}/>
            <div className={style.paymentBlock}>
                <div className={style['paymentBlock-title']}>
                    Данные об оплате
                </div>
                <div className={style['paymentBlock-wrapper']}>
                    {data.paymentType === 1 &&
                        // <FieldFormik name='data.finalPriceUsd'
                        //              text={values.data.finalPriceUsd}
                        //              typeInput='input-date'
                        //              label='Общая стоимость, USD'
                        //              className={style['input-payment']}/>

                        <>
                            {data.paymentType === 1 &&
                                <>
                                    <FieldFormik name='data.priceUsdPart_1'
                                                 text={values.data.priceUsdPart1}
                                                 typeInput='input-date'
                                                 label='Валютная часть 1'
                                                 className={style['input-payment']}/>
                                    <FieldFormik name='data.priceUsdPart_2'
                                                 text={values.data.priceUsdPart2}
                                                 typeInput='input-date'
                                                 label='Валютная часть 2'
                                                 className={style['input-payment']}/>
                                    <FieldFormik name='data.priceUsdPart_3'
                                                 text={values.data.priceUsdPart3}
                                                 typeInput='input-date'
                                                 label='Валютная часть 3'
                                                 className={style['input-payment']}/>
                                </>
                            }
                        </>
                    }
                    {data.paymentType === 2 &&
                        <div className={style.firstBlock}>
                            <FieldFormik name='data.finalPriceByn'
                                         text={values.data.finalPriceByn}
                                         typeInput='input-date'
                                         label='Финальная стоимость, руб' className={style['input-payment']}/>
                            {user.roleId === 2 &&
                                <div className={style.message}>Сумма указана за вычетом комиссии</div>}
                        </div>
                    }
                    {data.paymentType === 3 &&
                        <>
                            <div className={style.firstBlock}>
                                <FieldFormik name='data.finalFirstPartPriceByn'
                                             label='Стоимость услуги (Первый взнос), BYN'
                                             placeholder='Первоначальный взнос, BYN'
                                             typeInput='input-currency' type={'number'}
                                             className={style['input-payment']}/>
                                {user.roleId === 2 &&
                                    <div className={style.message}>Сумма указана за вычетом комиссии</div>}
                            </div>
                            <FieldFormik name='data.finalSecondPartPriceByn'
                                         text={values.data.finalSecondPartPriceByn}
                                         typeInput='input-date'
                                         label='Стоимость услуги (Второй взнос), BYN'
                                         className={style['input-payment']}/>
                            <FieldFormik name='data.finalPriceUsd'
                                         text={values.data.finalPriceUsd + " " + data.trip.currency}
                                         typeInput='input-date'
                                         label='Сумма оплаты принимающей стороне'
                                         className={style['input-payment']}/>
                        </>
                    }
                    {data.paymentType === 4 &&
                        <>
                            <div className={style.firstBlock}>
                                <FieldFormik name='data.finalPriceByn'
                                             text={values.data.finalPriceByn}
                                             typeInput='input-date'
                                             label='Финальная стоимость, руб' className={style['input-payment']}/>

                                {user.roleId === 2 &&
                                    <div className={style.message}>Сумма указана за вычетом комиссии</div>}
                            </div>
                            <FieldFormik name='data.finalPriceUsd'
                                         text={values.data.finalPriceUsd + " " + data.trip.currency}
                                         typeInput='input-date'
                                         label='Сумма оплаты принимающей стороне'
                                         className={style['input-payment']}/>
                        </>
                    }
                    {data.paymentType === 5 &&
                        <>
                            <div className={style.firstBlock}>
                                <FieldFormik name='data.finalPriceByn'
                                             text={values.data.finalPriceByn}
                                             typeInput='input-date'
                                             label='Финальная стоимость, руб' className={style['input-payment']}/>

                                {user.roleId === 2 &&
                                    <div className={style.message}>Сумма указана за вычетом комиссии</div>}
                            </div>
                            <FieldFormik name='data.priceUsdType5Part1'
                                         text={values.data.priceUsdType5Part1}
                                         typeInput='input-date'
                                         label='Валютная часть 1'
                                         className={style['input-payment']}/>
                            <FieldFormik name='data.priceUsdType5Part1'
                                         text={values.data.priceUsdType5Part2}
                                         typeInput='input-date'
                                         label='Валютная часть 2'
                                         className={style['input-payment']}/>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
